<template>
	<v-expansion-panel
		expand
		class="elevation-0"
		v-model="panels"
		:focusable="true">
		<v-expansion-panel-content class="background darken-1 launcher-panel">
			<template v-slot:header>
				<div class="header-content">
					<v-icon class="mr-2">account_circle</v-icon>
					Vos dernières demandes
					<v-progress-linear
						v-if="user_last_jrs_loading"
						indeterminate
						:height="2"
						class="ml-2 my-0"
						color="primary">
					</v-progress-linear>
				</div>
			</template>
			<v-card class="background darken-1">
				<v-card-text class="pt-0">
					<table>
						<colgroup>
							<col style="width: 0px">
							<col style="width: 0px">
							<col style="width: auto">
							<col style="width: 0px">
							<col style="width: 0px">
						</colgroup>
						<tbody>
							<tr v-for="jr in user_last_jrs" :key="jr.id">
								<td>
									<v-tooltip bottom color="background">
										<template v-slot:activator="{ on }">
											<router-link
												v-on="on"
												:to="{name: 'Maestro job', params: {jr_id: jr.id}}"
												target="_blank">
												<v-btn
													flat icon
													v-on="on"
													class="ma-0">
													<v-icon>open_in_new</v-icon>
												</v-btn>
											</router-link>
										</template>
										<span>#{{ jr.id }} Détails</span>
									</v-tooltip>
								</td>
								<td class="nowrap">
									{{ jr.descriptor.label }}
								</td>
								<td>
									<div class="line-break-anywhere">
										{{ jr.infos.label || '-' }}
									</div>
									<div class="caption line-break-anywhere">
										<span class="background--text text--lighten-5">
											{{ jr.infos.title || '-' }}
										</span>
									</div>
								</td>
								<td :class="$colors.setColorText(jr)">
									<div>{{ jr.status_text }}</div>
									<div class="caption text-right">
										{{ Math.floor(jr.progress) }}%
									</div>
								</td>
								<td>
									<v-tooltip bottom color="background">
										<template v-slot:activator="{ on }">
											<v-btn
												flat icon
												class="ma-0"
												v-on="on"
												@click="duplicateJR(jr.id)">
												<v-icon>content_copy</v-icon>
											</v-btn>
										</template>
										<span>Dupliquer la demande</span>
									</v-tooltip>
								</td>
							</tr>
						</tbody>
					</table>
					<v-toolbar
						v-if="user_last_jrs.length"
						flat
						color="transparent"
						:height="42"
						class="paginator">
						<v-spacer></v-spacer>
						{{ user_last_jrs_pagin }}
						<v-btn
							flat icon
							:disabled="user_last_jrs_page === 1"
							@click="user_last_jrs_page--; fetchUserLastJrs()">
							<v-icon>chevron_left</v-icon>
						</v-btn>
						<v-btn
							flat icon
							class="mr-0"
							:disabled="user_last_jrs_page === user_last_jrs_nb_page"
							@click="user_last_jrs_page++; fetchUserLastJrs()">
							<v-icon>chevron_right</v-icon>
						</v-btn>
					</v-toolbar>
				</v-card-text>
			</v-card>
		</v-expansion-panel-content>

		<v-expansion-panel-content
			class="background darken-1 launcher-panel"
			v-if="jd_selected">
			<template v-slot:header>
				<div class="header-content">
					<v-icon class="mr-2">account_tree</v-icon>
					Les derniers {{ jd_selected.label }}
					<v-progress-linear
						v-if="jd_last_jrs_loading"
						indeterminate
						:height="2"
						class="ml-2 my-0"
						color="primary">
					</v-progress-linear>
				</div>
			</template>
			<v-card class="background darken-1">
				<v-card-text class="pt-0">
					<table>
						<colgroup>
							<col style="width: 0px">
							<col style="width: 0px">
							<col style="width: auto">
							<col style="width: 0px">
							<col style="width: 0px">
						</colgroup>
						<tbody>
							<tr v-for="jr in jd_last_jrs" :key="jr.id">
								<td>
									<v-tooltip bottom color="background">
										<template v-slot:activator="{ on }">
											<router-link
												v-on="on"
												:to="{name: 'Maestro job', params: {jr_id: jr.id}}"
												target="_blank">
												<v-btn
													flat icon small
													v-on="on"
													class="ma-0">
													<v-icon small>open_in_new</v-icon>
												</v-btn>
											</router-link>
										</template>
										<span>#{{ jr.id }} Détails</span>
									</v-tooltip>
								</td>
								<td>
									<div class="nowrap">
										{{ jr.descriptor.label }}
									</div>
									<div class="caption nowrap">
										<v-icon
											small
											color="background lighten-3">
											person
										</v-icon>
										{{ jr.requestor.name }}
									</div>
								</td>
								<td>
									<div class="line-break-anywhere">
										{{ jr.infos.label || '-' }}
									</div>
									<div class="caption line-break-anywhere">
										<span class="background--text text--lighten-5">
											{{ jr.infos.title || '-' }}
										</span>
									</div>
								</td>
								<td :class="$colors.setColorText(jr)">
									<div>{{ jr.status_text }}</div>
									<div class="text-right caption">
										{{ Math.floor(jr.progress) }}%
									</div>
								</td>
								<td>
									<v-tooltip bottom color="background">
										<template v-slot:activator="{ on }">
											<v-btn
												flat icon
												class="ma-0"
												v-on="on"
												@click="duplicateJR(jr.id)">
												<v-icon>content_copy</v-icon>
											</v-btn>
										</template>
										<span>Dupliquer la demande</span>
									</v-tooltip>
								</td>
							</tr>
						</tbody>
					</table>
					<v-toolbar
						v-if="jd_last_jrs.length"
						flat
						color="transparent"
						:height="42"
						class="paginator">
						<v-spacer></v-spacer>
						{{ jd_last_jrs_pagin }}
						<v-btn
							flat icon
							:disabled="jd_last_jrs_page === 1"
							@click="jd_last_jrs_page--; fetchJdLastJrs()">
							<v-icon>chevron_left</v-icon>
						</v-btn>
						<v-btn
							flat icon
							class="mr-0"
							:disabled="jd_last_jrs_page === jd_last_jrs_nb_page"
							@click="jd_last_jrs_page++; fetchJdLastJrs()">
							<v-icon>chevron_right</v-icon>
						</v-btn>
					</v-toolbar>
				</v-card-text>
			</v-card>
		</v-expansion-panel-content>
	</v-expansion-panel>
</template>

<script>

export default {
	props: [ 'jd_selected', 'jds' ],
	data () {
		return {
			panels: [false, false],
			user_last_jrs: [],
			user_last_jrs_count: 0,
			user_last_jrs_page: 1,
			user_last_jrs_loading: false,
			jd_last_jrs: [],
			jd_last_jrs_count: 0,
			jd_last_jrs_page: 1,
			jd_last_jrs_loading: false
		}
	},
	computed: {
		user () {
			return this.$store.getters.user
		},
		user_last_jrs_nb_page () {
			return Math.ceil(this.user_last_jrs_count / 10)
		},
		user_last_jrs_pagin () {
			let start = (this.user_last_jrs_page * 10) - 9
			let end = Math.min((this.user_last_jrs_page * 10), this.user_last_jrs_count)
			return `${start} - ${end} sur ${this.user_last_jrs_count}`
		},
		jd_last_jrs_nb_page () {
			return Math.ceil(this.jd_last_jrs_count / 10)
		},
		jd_last_jrs_pagin () {
			let start = (this.jd_last_jrs_page * 10) - 9
			let end = Math.min((this.jd_last_jrs_page * 10), this.jd_last_jrs_count)
			return `${start} - ${end} sur ${this.jd_last_jrs_count}`
		}
	},
	watch: {
		panels (newVal, oldVal) {
			if (newVal[0]) {
				if (newVal[0] !== oldVal[0]) this.fetchUserLastJrs()
			}
			if (newVal[1]) {
				if (newVal[1] !== oldVal[1]) this.fetchJdLastJrs()
			}
		},
		jd_selected () {
			this.jd_last_jrs = []
			this.$set(this.panels, 1, false)
		}
	},
	methods: {
		fetchUserLastJrs () {
			this.user_last_jrs_loading = true
			let filters = {
				user_id: this.user.maestroUserId,
				page: this.user_last_jrs_page,
				per_page: 10
			}
			this.$EsMaestro.jobrequest_list_light(filters)
				.then(results => {
					this.user_last_jrs = results.jobs
					this.user_last_jrs_count = results.count
				})
				.catch(error => {
					this.$Toaster({
						title: 'Erreur lors de la récupération des jobs',
						content: error.message,
						type: 'error',
						loading: false,
						timeout: 0
					})
				})
				.finally(() => {
					this.user_last_jrs_loading = false
				})
		},
		fetchJdLastJrs () {
			this.jd_last_jrs_loading = true
			let filters = {
				jd_id: this.jd_selected.id,
				page: this.jd_last_jrs_page,
				per_page: 10
			}
			this.$EsMaestro.jobrequest_list_light(filters)
				.then(results => {
					this.jd_last_jrs = results.jobs
					this.jd_last_jrs_count = results.count
				})
				.catch(error => {
					this.$Toaster({
						title: 'Erreur lors de la récupération des jobs',
						content: error.message,
						type: 'error',
						loading: false,
						timeout: 0
					})
				})
				.finally(() => {
					this.jd_last_jrs_loading = false
				})
		},
		duplicateJR (jr_id) {
			this.$EsMaestro.jobrequest_read(jr_id)
				.then(result => {
					this.$Bus.$emit('launcher', {
						dialog: true,
						jd_id: result.descriptor_id,
						direct_edit: true,
						parameters: result.parameters
					})
					for (const jd of this.jds) {
						if (jd.id === result.descriptor_id) {
							this.$emit('open-form', jd)
							break
						}
					}
				})
				.catch(error => {
					console.log(error)
				})
		}
	}
}
</script>

<style scoped lang="stylus">
>>>.launcher-panel
	.v-expansion-panel__header
		padding-left: 36px
		&:hover
			color: var(--v-primary-base)
			.v-icon
				color: var(--v-primary-base) !important
	.header-content
		display: flex
		align-items: center
		text-wrap: nowrap
	.v-expansion-panel__header__icon
		left: 0px
		position: absolute

.nowrap
	text-wrap: nowrap

.line-break-anywhere
	line-break: anywhere

table
	width: 100%
	border-radius: 8px
	th
	td
		padding: 2px 8px
		border-top: 1px solid var(--v-background-base)
		vertical-align: top
	tr:last-child
		td
			border-bottom: 1px solid var(--v-background-base)

.paginator
	>>>.v-toolbar__content
		padding: 0
</style>



// WEBPACK FOOTER //
// src/pages/maestro/launcher/launcher_history.vue